import api from "./api";
import endpoints from "./endpoints";

export default {
  get: async function (languages, attributeGroupId, valueInherits) {
    const response = await api.get(endpoints.attributeManager.attributes.get, {
      params: { languages, attributeGroupId, valueInherits }
    });
    return response.data;
  },
  update: async function (args) {
    const response = await api.post(endpoints.attributeManager.attributes.update, args, { params: {} });
    return response.data;
  },
  delete: async function (args) {
    const response = await api.post(endpoints.attributeManager.attributes.delete, args, { params: {} });
    return response.data;
  },
  getDefaultValues: async function (languages, attributeId) {
    const response = await api.get(endpoints.attributeManager.attributes.values.get, {
      params: { languages, attributeId }
    });
    return response.data;
  },
  getDefaultUnits: async function (languages, attributeId) {
    const response = await api.get(endpoints.attributeManager.attributes.units.get, {
      params: { languages, attributeId }
    });
    return response.data;
  },
  updateDefaultValues: async function (args) {
    const response = await api.post(endpoints.attributeManager.attributes.values.update, args, {
      params: {}
    });
    return response.data;
  },
  updateDefaultUnits: async function (args) {
    const response = await api.post(endpoints.attributeManager.attributes.units.update, args, {
      params: {}
    });
    return response.data;
  },
  deleteDefaultValues: async function (ids) {
    const response = await api.post(endpoints.attributeManager.attributes.values.delete, ids, {
      params: {}
    });
    return response.data;
  },
  deleteDefaultUnits: async function (ids) {
    const response = await api.post(endpoints.attributeManager.attributes.units.delete, ids, {
      params: {}
    });
    return response.data;
  },
  getDescendantAttributes: async function (languages, attributeGroupId, valueInherits) {
    const response = await api.get(endpoints.attributeManager.attributes.getDescendantAttributes, {
      params: { languages, attributeGroupId, valueInherits }
    });
    return response.data;
  },
  savedeepLTranslated: async function (model, sourceLanguage) {
    return api.post(endpoints.attributeManager.attributes.deepL, model, { params: { sourceLanguage: sourceLanguage } }).then((x) => Promise.resolve(x.data));
  },
  getDetails: async function (language, attributeIds) {
    const response = await api.post(endpoints.attributeManager.attributes.details, attributeIds, {
      params: { language }
    });
    return response.data;
  }
};
